import { FC } from 'react'

import { Row } from 'sections/articles/content-components/row'
import { BaseContentComponentProps } from 'sections/articles/content-components/types'
import { ComponentTextAndImageModel } from 'api'
import { TextOnly } from 'sections/articles/content-components/text-only'

import { FullWidthImage } from '../full-width-image'

interface TextAndImageProps extends BaseContentComponentProps<ComponentTextAndImageModel> {}
export const TextAndImage: FC<TextAndImageProps> = ({ data }) => {
  return (
    <Row {...data}>
      <TextOnly data={data.first_section} />
      <FullWidthImage
        data={{
          image: data.second_section_image,
          description: data.second_section_image_description,
          with_border: false,
        }}
      />
    </Row>
  )
}
